import React, { useEffect } from 'react'
import { Box } from './ui/Elements';
import Header from './ui/includes/Header';
import TopPromoBanner from './ui/includes/TopPromoBanner';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { privateRoute } from './routes/PrivateRoute';
import Footer from './ui/includes/Footer';
import { useCookies } from 'react-cookie';
import i18n from './Languages/INEXT';
import { redirectToAppStore } from './utils/appStoreRedirect';

function App() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' })
	}, [location]);

	// QR / deep-link: ?download=true → store on mobile, /download on desktop
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		if (queryParams.get('download') === 'true') {
			if (!redirectToAppStore()) {
				navigate('/download', { replace: true });
			}
		}
	}, [location, navigate]);

	const [cookies, setCookie] = useCookies(['lang']);

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		setCookie('lang', lng, { path: '/' });
	};

	return (
		<>
			<Box>
				<Header />
				<TopPromoBanner />
				<Routes>
					{privateRoute.map((list, key) => (
						<Route key={key} {...list} />
					))}
				</Routes>
				<Footer />
			</Box>
		</>
	);
}

export default App;
